import React from 'react'
import ButtonList from './ButtonList';
import VideoContainer from './VideoContainer';


const MainConatiner = () => {
  return (
    <div className='overflow-hidden'>
      <ButtonList/>
      <VideoContainer/>
    </div>
  )
}

export default MainConatiner;
